/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AffiliatedGroupDetail } from '../../models/affiliated-group-detail';
import { AffiliatedGroupSave } from '../../models/affiliated-group-save';

export interface UpdateAffiliatedGroup$Params {
  id: number;
      body: AffiliatedGroupSave
}

export function updateAffiliatedGroup(http: HttpClient, rootUrl: string, params: UpdateAffiliatedGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<AffiliatedGroupDetail>> {
  const rb = new RequestBuilder(rootUrl, updateAffiliatedGroup.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AffiliatedGroupDetail>;
    })
  );
}

updateAffiliatedGroup.PATH = '/rest/admin/affiliated-group/{id}';
